import React, { useState } from "react";
import { Box, Button, Divider, Grid2, Paper, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import ContactsIcon from "@mui/icons-material/Contacts";
import PersonIcon from "@mui/icons-material/Person";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import { TabHeader } from "../../components/profile/accountInformation/TabHeader";
import { SectionHeader } from "../../components/profile/accountInformation/SectionHeader";
import { InfoSection } from "../../components/profile/accountInformation/InfoSection";
import { formatDateTimeStamp } from "../../utils/utils";
import { DELETE_ACCOUNT_BUTTON } from "../../styles/ButtonStyles";
import { UpdateUserDetails } from "./UpdateUserDetails";

export const AccountInformation = ({ userDetails }) => {
  const [openModal, setOpenModal] = useState(false);
  const [fieldToEdit, setFieldToEdit] = useState(null);
  const [fieldValue, setFieldValue] = useState("");

  const handleEditClick = (label, value) => {
    setFieldToEdit(label);
    setFieldValue(value);
    setOpenModal(true);
  };

  const handleCloseModal = () => setOpenModal(false);

  return (
    <>
      {/* Header */}
      <TabHeader
        title="Account Information"
        breadcrumb="Profile - Account Information"
        IconComponent={HomeIcon}
      />

      {/* Personal Information */}
      <Box sx={{ width: "100%", p: 1, mt: 2 }}>
        <Paper
          elevation={2}
          sx={{ width: "100%", borderRadius: 2, backgroundColor: "#fff" }}
        >
          <SectionHeader
            IconComponent={ContactsIcon}
            title="Personal Information"
          />
          <Divider />

          <InfoSection
            label="Name"
            value={`${userDetails.first_name} ${userDetails.last_name}`}
            onEdit={handleEditClick}
          />
          <InfoSection
            label="Address"
            value={userDetails?.address ? userDetails.address : "-"}
            onEdit={handleEditClick}
          />
          <InfoSection
            label="Phone Number"
            value={`+91 ${userDetails.contact}`}
            onEdit={handleEditClick}
          />
          <InfoSection
            label="Company"
            value={userDetails.company ? userDetails.company : "-"}
            onEdit={handleEditClick}
          />
        </Paper>
      </Box>

      {/* Account Information */}
      <Box sx={{ width: "100%", p: 1, mt: 2 }}>
        <Paper
          elevation={2}
          sx={{ width: "100%", borderRadius: 2, backgroundColor: "#fff" }}
        >
          <SectionHeader
            IconComponent={PersonIcon}
            title="Account Information"
          />
          <Divider />

          <InfoSection
            label="Email"
            value={userDetails.email}
            onEdit={handleEditClick}
          />

          <InfoSection
            label="Change Password"
            value="**************"
            onEdit={handleEditClick}
          />

          <InfoSection
            label="Member Since"
            value={formatDateTimeStamp(userDetails.created_at)}
            onEdit={handleEditClick}
          />
        </Paper>
      </Box>

      {/* Delete Account */}
      <Box sx={{ width: "100%", p: 1, mt: 2 }}>
        <Paper
          elevation={2}
          sx={{ width: "100%", borderRadius: 2, backgroundColor: "#fff" }}
        >
          <SectionHeader IconComponent={PersonRemoveIcon} title="Account" />
          <Divider />

          <Grid2 container spacing={1} sx={{ pt: 2, pl: 4, pr: 4 }}>
            <Grid2 size={12}>
              <Typography variant="body2" fontWeight="bold">
                Delete Account
              </Typography>
            </Grid2>
          </Grid2>

          <Grid2
            container
            spacing={1}
            sx={{
              pt: 2,
              pl: 4,
              pr: 4,
              display: "flex",
              alignSelf: "anchor-center",
            }}
          >
            <Grid2 size={10}>
              <Typography variant="body2" color="textSecondary">
                Keep in mind that upon deleting your account all of your account
                information will be deleted without the possibility of
                restoration.
              </Typography>
            </Grid2>
            <Grid2 size={2}>
              <Button variant="contained" sx={DELETE_ACCOUNT_BUTTON}>
                Delete Account
              </Button>
            </Grid2>
          </Grid2>
        </Paper>
      </Box>

      <UpdateUserDetails
        open={openModal}
        onClose={handleCloseModal}
        fieldToEdit={fieldToEdit}
        fieldValue={fieldValue}
        userDetails={userDetails}
      />
    </>
  );
};
